var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeroProductos'),(false)?_c('CarouselPropio'):_vm._e(),_c('Productos',{attrs:{"id":"seccion-productos"}}),_c('Promo'),_c('Redes'),_c('WhatsappFlotante')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }